<template>
  <router-view :reset.sync="reset" />
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      reset: {
        editState: 'editing'
      }
    }
  }
}
</script>

<style scoped>
</style>